// src/pages/Login.tsx
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import LoginForm from "../components/Login/LoginForm";

export const Login = () => {
	return (
		<Container maxWidth="sm">
			<Box
				sx={{
					padding: { xs: "1rem", sm: "2rem" },
					margin: "auto",
					mt: { xs: 4, md: 8 }
				}}
			>
				<Box sx={{ textAlign: "center", mb: 2 }}>
					<img
						src={"/favicon.ico"}
						alt="logo"
						style={{ width: 100, height: 100 }}
					/>
				</Box>
				<Typography
					variant="h4"
					component="h2"
					sx={{
						textAlign: "center",
						marginBottom: { xs: "1.5rem", sm: "2rem" },
						fontWeight: 700,
						fontSize: { xs: "1.5rem", sm: "2.125rem" }
					}}
				>
					FashionBazi Inventory and Billing System
				</Typography>
				<LoginForm />
			</Box>
		</Container>
	);
};
